import { StepContainer } from './step-container';
import { Step } from './step';

function isInstanceOfReactComponent(instance, ReactComponent) {
  if (instance != null && instance.type != null) {
    if (instance.type === ReactComponent) {
      return true;
    }

    // support for react-hot-loader components
    if (instance.type.name === 'ProxyFacade' && instance.type.displayName === ReactComponent.name) {
      return true;
    }
  }

  return false;
}

/**
 * Checks if instance is a <Step />.
 * @param {Object} instance - Instance to check type of.
 * @returns {Boolean} - Returns true if instance is a <Step />.
 */
export function isInstanceOfStep(instance) {
  return isInstanceOfReactComponent(instance, Step);
}

/**
 * Checks if instance is a <StepContainer />.
 * @param {Object} instance - Instance to check type of.
 * @returns {Boolean} - Returns true if instance is a <StepContainer />.
 */
export function isInstanceOfStepContainer(instance) {
  return isInstanceOfReactComponent(instance, StepContainer);
}
